import React from 'react';
import { Segmented, Typography, theme } from 'antd';
import { useTranslation } from 'react-i18next';

export type AppointmentBookingMode = 'resource' | 'service';

interface BookingModeSelectorProps {
  showServiceMode: boolean;
  value: AppointmentBookingMode;
  onChange: (mode: AppointmentBookingMode) => void;
}

export const BookingModeSelector: React.FC<BookingModeSelectorProps> = ({
  showServiceMode,
  value,
  onChange
}) => {
  const { token } = theme.useToken();
  const { t } = useTranslation('manage');

  if (!showServiceMode) {
    return null;
  }

  const options = [
    { label: t('appointmentComponents.create.bookingMode.service'), value: 'service' as const },
    { label: t('appointmentComponents.create.bookingMode.resource'), value: 'resource' as const }
  ];

  return (
    <div style={{ marginBottom: token.marginLG }}>
      <Segmented
        block
        value={value}
        onChange={(next) => onChange(next as AppointmentBookingMode)}
        options={options}
        aria-label={t('appointmentComponents.create.bookingMode.label')}
      />
      <Typography.Text type="secondary" style={{ display: 'block', marginTop: token.marginXS, fontSize: token.fontSizeSM }}>
        {value === 'resource'
          ? t('appointmentComponents.create.bookingMode.resourceHint')
          : t('appointmentComponents.create.bookingMode.serviceHint')}
      </Typography.Text>
    </div>
  );
};
